import gql from 'graphql-tag'


export const CreateActivity = gql`
mutation CreateActivity($name: String, $eventSummary: String, $category: String, $start: DateTime, $end: DateTime,  $classroomId: ID, $timed: Boolean) {
  createActivity(name: $name, eventSummary: $eventSummary, category: $category, start: $start, end: $end,  classroomId: $classroomId, timed: $timed) {
    activity {
      id
      name
      eventSummary
      category
      classroom {
        id
        name
      }
      start
      end
      timed
    }
  }
}
`


export const UpdateActivity = gql`
mutation UpdateActivity($id: ID!,$name: String, $eventSummary: String, $category: String, $start: DateTime, $end: DateTime, $timed: Boolean) {
  updateActivity(id: $id,name: $name, eventSummary: $eventSummary, category: $category, start: $start, end: $end, timed: $timed) {
    activity {
      id
      name
      eventSummary
      category
      classroom {
        id
        name
      }
      start
      end
      timed
    }
  }
}
`


export const DeleteActivity = gql`
mutation DeleteActivity($id: ID!) {
  deleteActivity(id: $id) {
    id_
  }
}
`
